/** Chunk types from Lex AI WebSocket (server → client) */
export type ChatMessageChunkType = 'INIT' | 'PART' | 'ERROR' | 'END';

/** Single chunk from the Lex AI WebSocket stream */
export interface ChatMessageChunk {
  type: ChatMessageChunkType;
  text: string;
  sessionId?: string;
  awsRequestId?: string;
}

/** One message in the chat UI (user or assistant) */
export interface ChatMessage {
  id: string;
  role: 'user' | 'assistant';
  text: string;
  time?: string;
  awsRequestId?: string;
}

/** Outbound payload (client → server). action/route for API Gateway WebSocket route selection. */
export interface ChatOutboundPayload {
  action: string;
  message: string;
  route?: string;
  sessionId?: string;
}

/** Feedback evaluation */
export type FeedbackEvaluation = 'POSITIVE' | 'NEGATIVE';

/** Allowed category for negative feedback */
export type FeedbackCategory =
  | 'inaccurate'
  | 'wrongCitations'
  | 'incomplete'
  | 'technicalIssue'
  | 'other';

/** Body for POST /lexipub/chatbot/v1/feedback */
export interface LexAiFeedbackPayload {
  awsRequestId?: string;
  sessionId?: string;
  evaluation: FeedbackEvaluation;
  categories?: { category: FeedbackCategory }[];
  turnNumber: number;
  comment?: string;
}

export const CHAT_MAX_MESSAGE_LENGTH = 3000;
export const CHAT_MAX_FEEDBACK_COMMENT_LENGTH = 500;
export const CHAT_TIMEOUT_MS = 30_000;
